<template>
  <FormPart
      :Item="Ticket"
      :setItemForm="setItemForm"
      :submitData="submitData"
      @onSuccess="onSuccess"
      @onFail="onFail"
  >
    <template
        v-slot:default="{
          loading,
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
            lg="6"
        >
          <v-text-field
              v-model="ItemForm.pricingEmail"
              :error-messages="errors.pricingEmail"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="E-mail"
              :clearable="true"
          />
        </v-col>

        <v-col
            cols="12"
            lg="6"
        >
          <v-text-field
              v-model="ItemForm.pricingName"
              :error-messages="errors.pricingName"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Meno"
              :clearable="true"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.pricingMessage"
              :error-messages="errors.pricingMessage"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Správa"
              :rows="5"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-btn
              type="submit"
              :rounded="true"
              :outlined="true"
              :loading="loading"
              :disabled="loading"
              color="primary"
          >
            <v-icon>
              mdi-send
            </v-icon>

            Odoslať
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </FormPart>
</template>

<script>
  import TicketPricing from '@/services/ticket-pricing'

  import FormPart from '@/components/_Part/Form'

  export default {
    name: 'FormPricingSend',
    props: [
      'Ticket'
    ],
    emits: [
      'refresh'
    ],
    components: {
      FormPart
    },
    methods: {
      setItemForm(Item) {
        return {
          token: Item.token,
          pricingEmail: Item.Project?.Client?.contactEmail,
          pricingName: Item.Project?.Client?.contactName,
          pricingMessage: null
        }
      },
      submitData(ItemForm) {
        return TicketPricing
          .send({
            data: ItemForm
          })
      },
      onSuccess() {
        this.$emit('refresh')
      },
      onFail(response) {
        if (response.status !== 409) {
          this.$router.push('/tickets')
        }
      }
    }
  }
</script>
